export const TIPS_SHARE_SHEET_CLOSE_ANIMATION_MS = 240;
